import { render, staticRenderFns } from "./Props.vue?vue&type=template&id=20c4ac61&scoped=true&"
import script from "./Props.vue?vue&type=script&lang=js&"
export * from "./Props.vue?vue&type=script&lang=js&"
import style0 from "./Props.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Props.vue?vue&type=style&index=1&id=20c4ac61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4ac61",
  null
  
)

export default component.exports